import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface FeatherIconProps {
  color?: string;
  isActive?: boolean;
  size?: number;
}

export default function FeatherIcon({ color = '#A19F97', isActive = false, size = 24 }: FeatherIconProps) {
  if (isActive) {
    return (
      <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Path 
          d="M3.5 20.6561C3.5 20.6561 3.99166 8.65565 17.0741 3.8347C28.2815 0.847713 14.6693 12.4665 14.6693 12.4665L9.06563 13.0168L11.6659 15.075C9.11398 16.8688 6.5631 17.7555 4.0112 17.7318"
          fill="white"
          stroke="#151515"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path 
          d="M11.2168 20.6562H17.6269"
          stroke="#151515"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    );
  }

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path 
        d="M3.5 20.6561C3.5 20.6561 3.99166 8.65565 17.0741 3.8347C28.2815 0.847713 14.6693 12.4665 14.6693 12.4665L9.06563 13.0168L11.6659 15.075C9.11398 16.8688 6.5631 17.7555 4.0112 17.7318"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path 
        d="M11.2168 20.6562H17.6269"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
